import { Dog, Cat, Plus, Trash2 } from "lucide-react";
import { TextField, Label, ChoiceGroup } from "./Fields";
import { FoodFields } from "./FoodFields";
import { emptyFood } from "./constants";

const TIPOS = [
  { value: "perro", label: "Perro" },
  { value: "gato", label: "Gato" },
];

export const PetCard = ({ pet, pi, errors, onChange, onRemove, canRemove }) => {
  const set = (k, v) => onChange({ ...pet, [k]: v });
  const setFood = (j, f) => set("alimentos", pet.alimentos.map((a, i) => (i === j ? f : a)));
  const Icon = pet.tipo === "gato" ? Cat : Dog;

  return (
    <div data-testid={`cf-pet-${pi}`} className="rounded-3xl bg-white border border-[#E3E7E2] p-4 sm:p-5 space-y-4 card-shadow">
      <div className="flex items-center gap-3">
        <span className="grid place-items-center w-10 h-10 rounded-2xl bg-peach text-coral"><Icon className="w-5 h-5" /></span>
        <p className="font-display text-lg font-bold text-charcoal flex-1">{pet.nombre_mascota.trim() || `Mascota ${pi + 1}`}</p>
        {canRemove && (
          <button type="button" data-testid={`cf-pet-${pi}-remove`} onClick={onRemove} aria-label="Quitar mascota" className="p-2 rounded-xl text-muted-moss hover:text-red-500 hover:bg-red-50">
            <Trash2 className="w-4 h-4" />
          </button>
        )}
      </div>

      <div>
        <Label>¿Es perro o gato?</Label>
        <ChoiceGroup testId={`cf-pet-${pi}-tipo`} options={TIPOS} value={pet.tipo} onChange={(v) => set("tipo", v)} error={errors[`m${pi}.tipo`]} />
        {errors[`m${pi}.tipo`] && <span className="block mt-1 text-xs text-red-500">Campo obligatorio</span>}
      </div>

      <div className="grid grid-cols-[1fr_110px] gap-3">
        <TextField label="Nombre" testId={`cf-pet-${pi}-nombre`} value={pet.nombre_mascota} onChange={(e) => set("nombre_mascota", e.target.value)} error={errors[`m${pi}.nombre_mascota`]} placeholder="Ej: Luna" />
        <TextField label="Cantidad" testId={`cf-pet-${pi}-cantidad`} type="number" inputMode="numeric" min="1" value={pet.cantidad} onChange={(e) => set("cantidad", e.target.value)} error={errors[`m${pi}.cantidad`]} />
      </div>
      <p className="-mt-2 text-xs text-muted-moss">Si tienes varias mascotas que comen lo mismo, puedes agruparlas e indicar la cantidad.</p>

      <div className="space-y-3">
        <p className="text-sm font-bold text-charcoal">¿Qué alimento(s) come?</p>
        {pet.alimentos.map((f, j) => (
          <FoodFields key={f._k} food={f} idx={j} pi={pi} errors={errors} onChange={(nf) => setFood(j, nf)}
            onRemove={() => set("alimentos", pet.alimentos.filter((_, i) => i !== j))} canRemove={pet.alimentos.length > 1} />
        ))}
        <button type="button" data-testid={`cf-pet-${pi}-add-food`} onClick={() => set("alimentos", [...pet.alimentos, emptyFood()])}
          className="w-full h-11 rounded-xl border border-dashed border-coral/60 text-coral text-sm font-semibold inline-flex items-center justify-center gap-1.5 hover:bg-peach/40 active:scale-[0.98] transition-transform">
          <Plus className="w-4 h-4" /> Agregar otro alimento
        </button>
      </div>
    </div>
  );
};
